export default __webpack_public_path__ + "static/media/selenium.f0d42a91.svg";